<template>
	<el-card>
		<el-tabs v-model="activetab" @tab-click="changetab">
			<el-tab-pane label="上传身份证" name="上传身份证"><iframe :src="src" :height="iframeheight" frameborder="0" width="99.3%" scrolling="auto"></iframe></el-tab-pane>
			<el-tab-pane label="承诺书" name="承诺书">
				<div class="wordcontext" :style="{ height: `${iframeheight}px` }">
					<div style="text-align: center;font-size:15pt;margin-bottom:20px;">海外快递进口身份证影印件证明承诺书</div>
					<div><b>申请人信息</b></div>
					<div style="padding-left:30px">
						<el-form :inline="true">
							<el-form-item label="姓名 :"><el-input v-model="wordinfo.name" size="mini"></el-input></el-form-item>
						</el-form>
						<el-form :inline="true">
							<el-form-item label="证件类型及名称 :"><span>身份证</span></el-form-item>
						</el-form>
						<el-form :inline="true">
							<el-form-item label="证件号码 :"><el-input size="mini" v-model="wordinfo.idcard"></el-input></el-form-item>
						</el-form>
						<el-form :inline="true">
							<el-form-item label="发证机关 :"><el-input size="mini" v-model="wordinfo.fzjg"></el-input></el-form-item>
						</el-form>
					</div>

					<div><b>运单信息</b></div>
					<div style="padding-left:30px">
						<el-form :inline="true">
							<el-form-item label="快递单号 :"><el-input size="mini" v-model="wordinfo.expressid"></el-input></el-form-item>
						</el-form>
					</div>
					<div><b>海关告知</b></div>
					<p><b>证明事项名称</b></p>
					<p>快件收发件人身份证件影印件</p>
					<p><b>证明用途</b></p>
					<p>办理个人物品类进出境快件报关手续。</p>
					<p><b>证明事项设定依据</b></p>
					<p>《中华人民共和国海关法》第四十七条；《海关总署关于启用新快件通关系统相关事宜的公告》（海关总署公告2016年第19号）第二条。</p>
					<p><b>承诺方式</b></p>
					<p>本证明事项采用书面承诺方式，申请人作出承诺的，应当向海关提交本人签字后的告知承诺书原件。</p>
					<p><b>适用对象</b></p>
					<p>
						本证明事项申请人可自主选择是否采用告知承诺制方式办理。申请人不愿承诺或无法承诺的，应当依法提交证明材料。申请人有较严重的不良信用记录或者存在曾作出虚假承诺等情形的，在信用修复前不适用告知承诺制。
					</p>
					<p><b>承诺的效力</b></p>
					<p>申请人向海关提交书面告知承诺书，即是承诺已经符合告知的条件、要求，并愿意承担不实承诺的法律责任，海关不要求申请人提交该项证明材料。</p>
					<p><b>不实承诺的责任</b></p>
					<p>对提供不实承诺办理相关事项的，海关依法撤销相关决定，采取信用惩戒措施，符合法定行政处罚情形的给予行政处罚。</p>
					<p><b>申请人承诺</b></p>
					<p>本人合法持有办理个人物品类进出境快件报关需要的身份证件，证件有效期为：</p>
					<div style="padding-left:30px;">
						<el-form :inline="true">
							<el-form-item label="开始时间">
								<el-date-picker  v-model="wordinfo.starttime" type="date" :editable="false" size="mini" style="width:150px"></el-date-picker>
							</el-form-item>
							<el-form-item label="结束时间">
								<el-date-picker v-model="wordinfo.endtime" type="date" :editable="false" size="mini" style="width:150px" @change="changeendtime"></el-date-picker>
								<el-checkbox v-model="wordinfo.checked" @change="setendtime">长期</el-checkbox>
							</el-form-item>
						</el-form>
					</div>
					<p>本人承诺：</p>
					<p>（一）无不良信用记录或者曾作出虚假承诺；</p>
					<p>（二）已经知晓海关告知的全部内容；</p>
					<p>（三）自身符合海关告知的相关条件要求；</p>
					<p>（四）接受海关对本证明事项的核查；</p>
					<p>（五）愿意承担不实承诺的法律责任；</p>
					<p>（六）上述承诺意思表示真实。</p>
					<p><b>申请人签名</b><span style="color:#b1b1b1;font-size:12pt;margin-left:5px">(请在下面空白区域手写签名)</span></p>
					<vue-esign ref="esign" :width="width" :height="150" :isCrop="isCrop" :lineWidth="lineWidth" :lineColor="lineColor" :bgColor.sync="bgColor" />
					<div style="text-align:center;" v-if="isshow">
						<el-button @click="resetsign" type="primary" size="mini">重写</el-button>
						<el-button @click="savesign" type="success" size="mini">确认</el-button>
					</div>
				</div>
			</el-tab-pane>
		</el-tabs>
	</el-card>
</template>
<script>
export default {
	components: {},
	data() {
		return {
			iframeheight: window.innerHeight - 105,
			width: window.innerWidth - 50,
			src: '',//上传身份证页面
			activetab: '上传身份证',
			wordinfo: {
				idcard: '',
				name: '',
				fzjg: '',
				expressid: '',
				starttime: '',
				endtime: '',
				checked: false
			},
			tabs: [{ name: '上传身份证' }, { name: '承诺书' }],
			isCrop: true,
			lineWidth: 5,
			lineColor: '#000000',
			bgColor: '#ffffff',
			isshow:true,
			divclass:'wordcontext'
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/onlinesign.scss');
		});
		this.init();
	},
	methods: {
		init() {
			this.src = document.location.protocol + '//api.kdfei.cn/idcard.html?id=65c7087e1ee84c2a2a289d8240c3b609';
		},
		changetab(tab) {
			this.activetab = this.tabs[tab.index].name;
		},
		resetsign() {
			this.$refs.esign.reset();
		},
		setendtime(){
			if(this.wordinfo.checked)
				this.wordinfo.endtime='';
		},
		changeendtime(){
			if(this.wordinfo.checked)
			{
				this.wordinfo.endtime='';
				this.$tool.message('您已勾选长期', 0);
			}
		},
		savesign() {
			var that=this;
			if(this.wordinfo.idcard!='')
			{
				if(!this.$tool.checkidcardformat(this.wordinfo.idcard)){
					this.$tool.message('请填写正确的身份证号', 0);
					return false;
				}
			}else
			{
				this.$tool.message('请填写身份证号', 0);
				return false;
			}
			if(this.wordinfo.name==''){
				this.$tool.message('请填写姓名', 0);
				return false;
			}
			if(this.wordinfo.fzjg==''){
				this.$tool.message('请填写发证机关', 0);
				return false;
			}
			if(this.wordinfo.expressid==''){
				this.$tool.message('请填写快递单号', 0);
				return false;
			}
			else{
				if(!this.$tool.isNumAndEnglist(this.wordinfo.expressid)){
					this.$tool.message('请输入一个正确的快递单号', 0);
					return false;
				}
			}
			if(this.wordinfo.starttime==''){
				this.$tool.message('请填写证件有效期开始时间', 0);
				return false;
			}
			if(this.wordinfo.endtime==''&&!this.wordinfo.checked){
				this.$tool.message('请填写证件有效期结束时间或者勾选长期', 0);
				return false;
			}
			that.isshow=false;
			this.$tool.message('正在上传');
			this.$refs.esign
				.generate()
				.then(res => {
					that.wordinfo.signimg=encodeURIComponent(res);
					//debugger
					this.$apipost.post.SaveCNS({wordinfo:that.wordinfo}).then(res => {
						if (res != '') {
							if(res.state=='1'){
								this.$tool.message('签名成功', 1);
							}
							else{
								that.isshow=true;
								this.$tool.message(res.message,0);
							}
						}
					});
				})
				.catch(err => {
					that.isshow=true;
					this.$tool.message('请签名', 0);
				});
		}
	}
};
</script>
